import { ArrowUpRight, LogIn, Mail, Phone } from "lucide-react";

const people = [
  {
    name: "Alan Morgan",
    photo: "/alan-avatar.jpg",
    title: "Business Owner",
    subtitle: "Web Designer",
    about: "Builds and manages your website, from the first design to hosting and search.",
    skills: ["Web Design", "Custom Code", "React", "Hosting", "SEO"],
    phone: { href: "tel:+16014419656", label: "(601) 441-9656" },
    email: "alan@rare-works.com",
  },
  {
    name: "Kayla Morgan",
    photo: "/kayla-avatar.jpg",
    title: "Director of Social Media",
    subtitle: "Director of Content Creation",
    about: "Runs your social media and designs the graphics, logos, and videos behind it.",
    link: { href: "https://www.facebook.com/RareWorksStudio", label: "Visit our business page" },
    skills: ["Social Media", "Content Creation", "Graphic Design", "Branding", "Reels & Video"],
    phone: { href: "tel:+17693781466", label: "(769) 378-1466" },
    email: "kayla@rare-works.com",
  },
];

const row = "flex items-center gap-3 px-4 py-3 rounded-xl bg-gray-800/60 border border-white/10 text-gray-300 hover:text-white hover:border-teal-500/50 transition-colors";

const Team = () => (
  <section className="relative min-h-screen pt-32 pb-24">
    <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="mb-16">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-white mb-4">Meet the Team</h1>
        <p className="text-xl text-gray-400 max-w-2xl">The people behind every page, line of code, and social post.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {people.map((p) => (
          <div key={p.name} className="p-8 rounded-2xl glass">
            <img
              src={p.photo}
              alt={p.name}
              className="w-32 h-32 rounded-2xl border border-white/10 object-cover mb-6"
            />
            <h2 className="text-2xl font-semibold text-white mb-1">{p.name}</h2>
            <p className="text-teal-400 font-medium">{p.title}</p>
            <p className="text-gray-400 text-sm mt-1">{p.subtitle}</p>
            <p className="text-gray-300 leading-relaxed mt-5">{p.about}</p>
            {p.link && (
              <a
                href={p.link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-2 text-teal-400 hover:text-teal-300 underline underline-offset-2 text-sm"
              >
                {p.link.label}
              </a>
            )}
            <p className="text-gray-400 text-sm mt-5">{p.skills.join(" · ")}</p>
            <div className="space-y-3 mt-6">
              <a href={p.phone.href} className={row}>
                <Phone className="w-4 h-4 text-gray-400" />
                {p.phone.label}
              </a>
              <a href={`mailto:${p.email}`} className={row}>
                <Mail className="w-4 h-4 text-gray-400" />
                {p.email}
              </a>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-8 rounded-2xl glass flex flex-col sm:flex-row sm:items-center gap-6">
        <div className="flex-1">
          <h2 className="text-2xl font-semibold text-white mb-2">Sales Reps</h2>
          <p className="text-gray-400 leading-relaxed">
            Know the business owners in your town?{" "}
            <a href="/careers.html" className="text-teal-400 hover:text-teal-300 underline underline-offset-2">
              See the open sales rep position
            </a>
            .
          </p>
        </div>
        <a
          href="https://leads.rare-works.com/rep/"
          className="shrink-0 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-gray-800/60 border border-white/10 hover:border-teal-500/50 text-gray-300 hover:text-white text-sm font-medium transition-colors"
        >
          <LogIn className="w-4 h-4 text-gray-400" />
          Rep sign in
        </a>
      </div>

      <div className="mt-16 p-8 rounded-2xl glass text-center">
        <h2 className="text-2xl font-semibold text-white mb-3">Ready to work with us?</h2>
        <p className="text-gray-400 mb-6">Whether you need a website, social media, or both, we can help.</p>
        <a
          href="/contact.html"
          className="inline-flex items-center gap-2 px-8 py-4 bg-linear-to-r/srgb from-teal-500 to-cyan-600 text-white rounded-xl font-medium hover:brightness-110 transition-[filter]"
        >
          Get in Touch
          <ArrowUpRight className="w-5 h-5" />
        </a>
      </div>
    </div>
  </section>
);

export default Team;
